<template>
  <div>
    <h3>General description</h3>
    <p>
      A constellation can be built from a set of one or more homogeneous
      geometries.
    </p>
    <p>A geometry can be set from different geometry types:</p>
    <ul>
      <li>Walker-Delta</li>
      <li>Walker-Star</li>
      <li>Global Streets of Coverage</li>
      <li>Custom</li>
    </ul>
    <p>
      However, a customizable geometry relies on the assumptions discussed
      below.
    </p>
    <h3>Hypotheses</h3>
    <p>A geometry is limited by the following hypotheses:</p>
    <ul>
      <li>the altitude and inclination are common to all the planes</li>
      <li>the number of spacecrafts per plane is independant of the plane</li>
      <li>the spacecrafts are evenly distributed within a plane</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeometry'
}
</script>
